"use client";

import React from "react";

import { type IZonesPayload } from "../../../map-panel-context";
import { ClusterSelectionPanelLayout } from "../cluster-selection/cluster-selection-panel-layout";

import { ZonesList } from "./zones-list";
import { ZonesSummary } from "./zones-summary";

interface ZonesPanelContentProps {
  payload: IZonesPayload | null;
  onZoneSelect: (previewId: string, documentId: string) => void;
}

const ZonesPanelContentComponent: React.FC<ZonesPanelContentProps> = ({ payload, onZoneSelect }) => {
  return (
    <ClusterSelectionPanelLayout>
      {payload?.showSummary !== false && (
        <ZonesSummary
          unassignedCount={payload?.unassignedCount ?? 0}
          zonesCount={payload?.zonesCount ?? 0}
        />
      )}
      <ZonesList
        sectionTitle={payload?.sectionTitle ?? ""}
        zones={payload?.zones ?? []}
        onZoneSelect={onZoneSelect}
      />
    </ClusterSelectionPanelLayout>
  );
};

export default React.memo(ZonesPanelContentComponent);
